import qs from 'query-string';

const identifyQueryParameters = () => qs.parse(window.location.search, { arrayFormat: 'bracket' });

export default identifyQueryParameters;
